export class AgenticAutofixError extends Error {
  readonly errorType: string | undefined

  constructor(message: string, errorType?: string | undefined) {
    super(message)
    this.name = 'AgenticAutofixError'
    this.errorType = errorType
  }
}

/**
 * Creates an AgenticAutofixError from a response body if it matches the expected structure, otherwise returns null.
 */
export function createAgenticAutofixErrorFromBody(body: unknown): AgenticAutofixError | null {
  if (
    body &&
    typeof body === 'object' &&
    'message' in body &&
    typeof body.message === 'string' &&
    'error_source' in body &&
    body.error_source === 'agentic_autofix'
  ) {
    const message = body.message

    const errorType = 'error_type' in body && typeof body.error_type === 'string' ? body.error_type : undefined

    return new AgenticAutofixError(message, errorType)
  }

  return null
}

export async function createAgenticAutofixErrorFromResponse(response: Response): Promise<AgenticAutofixError | null> {
  let body: unknown
  try {
    body = await response.json()
  } catch {
    // Ignore JSON parsing errors, we'll throw a generic error below
  }

  return createAgenticAutofixErrorFromBody(body)
}

export async function handleAgenticAutofixErrorResponse(response: Response) {
  const agenticAutofixError = await createAgenticAutofixErrorFromResponse(response)
  if (agenticAutofixError) {
    throw agenticAutofixError
  }

  throw new Error(`Request failed with status ${response.status}`)
}
